<template>
    <section class="trade-show-carousel">
        <b-container>
            <b-row class="justify-content-center">
                <b-col cols="12">
                    <div class="owl-carousel owl-theme">
                        <div class="item" v-for="(img, idx) in tradeImgs" :key="idx">
                            <b-img :src="img" fluid></b-img>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </section>
</template>

<script>
export default {
    data() {
        return {
            tradeImgs: [
                require('@/assets/images/tradeshow/ts_2005.jpg'),
                require('@/assets/images/tradeshow/ts_2007.jpg'),
                require('@/assets/images/tradeshow/ts_2008.jpg'),
                require('@/assets/images/tradeshow/ts_2009.jpg'),
                require('@/assets/images/tradeshow/ts_2010.jpg'),
                require('@/assets/images/tradeshow/ts_2011.jpg'),
                require('@/assets/images/tradeshow/ts_2012.jpg'),
                require('@/assets/images/tradeshow/ts_2013.jpg'),
                require('@/assets/images/tradeshow/ts_2016.jpg'),
                require('@/assets/images/tradeshow/ts_2017.jpg'),
            ]
        }
    },
    mounted() {
        $('.owl-carousel').owlCarousel({
            loop:true,
            margin:10,
            nav:true,
            navText: [
                'prev',
                'next'
            ],
            responsive:{
                0:{ items:1 },
                600:{ items:3 },
                1000:{ items:5 }
            }
        });
    },
}
</script>

<style lang="scss">
    .trade-show-carousel{
        padding-bottom: 75px;
    }
</style>